import type { ControlPoint } from '@rcs/data-schema';
import type { SegmentSpec } from '@rcs/physics';

/**
 * コースの制御点から、物理の区間ごとの力モデルを作る。
 * 制御点 `i` の区間種別が、`i` から次の制御点までの区間 `i` の力モデルになる
 * （サンプル軌道の区間番号と同じ並び）。
 */
export function toSegmentSpecs(controlPoints: readonly ControlPoint[]): SegmentSpec[] {
  return controlPoints.map((point): SegmentSpec => {
    switch (point.segment) {
      case 'lift':
        return { type: 'lift', liftSpeed: point.segmentParams.liftSpeed };
      case 'brake':
        return {
          type: 'brake',
          maxDeceleration: point.segmentParams.maxDeceleration,
          targetSpeed: point.segmentParams.targetSpeed,
        };
      case 'station':
        return { type: 'station', dispatchSpeed: point.segmentParams.dispatchSpeed };
      case 'block':
        return { type: 'block' };
      case 'launch':
        return {
          type: 'launch',
          targetSpeed: point.segmentParams.targetSpeed,
          maxAcceleration: point.segmentParams.maxAcceleration,
        };
      case 'normal':
        return { type: 'normal' };
    }
  });
}
